import { Slot } from 'expo-router';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Provider as UrqlProvider } from 'urql';
import { externalExchanges, getUrqlClient } from '@/client/urqlClient';
import Box from '@/components/UI/Box';

export default function ExternalLayoutRoute() {
  const client = getUrqlClient({
    key: 'external',
    exchanges: externalExchanges,
  });
  const { top } = useSafeAreaInsets();

  return (
    <UrqlProvider value={client}>
      <Box flex style={{ paddingTop: top }}>
        <Slot />
      </Box>
    </UrqlProvider>
  );
}
